import * as React from "react";
import { IdOrientation } from "../../../constants/IdOrientation";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ButtonHudNormal } from "../../generic/common/ButtonHudNormal";
import { ButtonSecondarySquareSmall } from "../../generic/common/ButtonSecondarySquareSmall";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { TextLoca } from "../../generic/text/TextLoca";
export var FoundEditOptions = function (_a) {
    var coop = _a.coop, coopState = _a.coopState, coopRequiredLevel = _a.coopRequiredLevel, onFilterMenuClick = _a.onFilterMenuClick, onChangeRequiredLevel = _a.onChangeRequiredLevel, selectedFilterLanguage = _a.selectedFilterLanguage;
    var updateRequiredLevel = function (level) {
        if (isNaN(level)) {
            return;
        }
        if (level < 9 || level > 999) {
            return;
        }
        onChangeRequiredLevel(level);
    };
    return (React.createElement("div", { className: "flex w100 flex--around" },
        React.createElement("div", null,
            React.createElement("div", { className: IdStyles.TextNormal + " " + IdStyles.TextAlignCenter + " w100" },
                React.createElement(TextLoca, { id: IdLoca.status })),
            React.createElement("input", { className: IdStyles.CoopFoundStatInput + " " + IdStyles.TextNormal + " " + IdStyles.TextAlignCenter + " margin--large", type: "text", value: coopState, readOnly: true })),
        React.createElement("div", null,
            React.createElement("div", { className: IdStyles.TextNormal + " " + IdStyles.TextAlignCenter + " w100" },
                React.createElement(TextLoca, { id: IdLoca.requiredLevel })),
            React.createElement("div", { className: "flex flex--aligned" },
                React.createElement(ButtonSecondarySquareSmall, { onClick: function () { return updateRequiredLevel(coopRequiredLevel - 1); } },
                    React.createElement(Icon, { icon: IdIcon.WhiteArrowIcn, styleId: IdStyles.IconSmall, orientation: IdOrientation.Left })),
                React.createElement("input", { className: IdStyles.CoopFoundStatInput + " " + IdStyles.TextNormal + " " + IdStyles.TextAlignCenter + " margin--large", type: "text", onChange: function (event) { return updateRequiredLevel(parseInt(event.target.value, 10)); }, value: coopRequiredLevel }),
                React.createElement(ButtonSecondarySquareSmall, { onClick: function () { return updateRequiredLevel(coopRequiredLevel + 1); } },
                    React.createElement(Icon, { icon: IdIcon.WhiteArrowIcn, styleId: IdStyles.IconSmall, orientation: IdOrientation.Right })))),
        React.createElement("div", { className: "flex flex--stacked flex--aligned" },
            React.createElement("div", { className: IdStyles.TextNormal + " " + IdStyles.TextAlignCenter + " w100" },
                React.createElement(TextLoca, { id: IdLoca.coopLanguage_title })),
            React.createElement("div", { className: "margin--large" },
                React.createElement(ButtonHudNormal, { onClick: onFilterMenuClick, className: "flex flex--guts" },
                    React.createElement(Icon, { icon: selectedFilterLanguage.assetName, styleId: IdStyles.IconMedium }))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/found-edit/FoundEditOptions.tsx
// module id = 2586
// module chunks = 3